var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuLiRiChangWeihui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "currentColor",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.092 10h-6.655C12.09 10 11 11.04 11 12.32v17.36c0 1.28 1.091 2.32 2.437 2.32h14.926c1.346 0 2.437-1.04 2.437-2.32V12.32c0-1.28-1.091-2.32-2.437-2.32h-1.697v7.73c0 .633-.757.996-1.29.618l-1.998-1.412-1.996 1.412c-.533.377-1.29.015-1.29-.618zM22 10h3.3v6.6l-1.105-.843a.894.894 0 00-1.09 0L22 16.6z"
  })));
}
export default SvgHuLiRiChangWeihui;